// COMPONENTS
import { StyledFormBG } from "../../styles/FormBG";
import RegisterHeader from "../../components/RegisterHeader";
import { RegisterCTA } from "./styled";
import FormDefault from "../../components/Form";
import InputBox from "../../components/InputBox";
import { StyledBtn } from "../../styles/Buttons";
import SelectBox from "../../components/SelectBox/SelectBox";

//CONTEXT
import { useContext } from "react";
import { UserContext } from "../../context/userContext";

import { registerSchema } from "../../schemas/schemas";

//LIBS
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {useForm} from "react-hook-form";

const RegisterPage = ()=>{

    const { submitRegister } = useContext(UserContext)
    
    const { register, handleSubmit, formState:{errors}, reset } = useForm({
        mode: "onBlur",
        resolver: yupResolver(registerSchema)
    });
    
    return(
        <StyledFormBG>
            
            <RegisterHeader/>
            <FormDefault title="Crie sua conta" callback={handleSubmit(submitRegister)}>
                <RegisterCTA>Rápido e grátis, vamos nessa!</RegisterCTA>
                
                <InputBox
                    label="Nome" name="name"
                    type="text" placeholder="Digite aqui seu nome"
                    register={register("name")} errors={errors.name} 
                />
                <InputBox
                    label="Email" name="email"
                    type="text" placeholder="Digite aqui seu email"
                    register={register("email")} errors={errors.email} 
                />
                
                <InputBox
                    label="Senha" name="password"
                    type="password" placeholder="Digite aqui sua senha"
                    register={register("password")} errors={errors.password} 
                />

                <InputBox
                    label="Confirmar Senha" name="passwordConf"
                    type="password" placeholder="Confirmar senha"
                    register={register("passwordConf")} errors={errors.passwordConf} 
                />

                <InputBox
                    label="Bio" name="bio"
                    type="text" placeholder="Fale sobre você"
                    register={register("bio")} errors={errors.bio} 
                />

                <InputBox
                    label="Contato" name="contact"
                    type="text" placeholder="Opção de contato"
                    register={register("contact")} errors={errors.contact} 
                />

                <SelectBox
                    label="Selecionar Módulo" name="module"
                    register={register("course_module")} errors={errors.course_module} 
                >
                    <option>Selecione o módulo</option>
                    <option value="Primeiro módulo(Introdução ao Frontend)">Primeiro módulo (Introdução ao Frontend)</option>
                    <option value="Segundo módulo (Frontend Avançado)">Segundo módulo (Frontend Avançado)</option>
                    <option value="Terceiro módulo (Introdução ao Backend)">Terceiro módulo (Introdução ao Backend)</option>
                    <option value="Quarto módulo (Backend Avançado)">Quarto módulo (Backend Avançado)</option>
                </SelectBox>

                <StyledBtn size="100%" BGcolor="var(--color-primary)">Cadastrar</StyledBtn>
            </FormDefault>

            
        </StyledFormBG>
        
    )

}

export default RegisterPage